//@flow
import React from 'react';
import {useCreateObjectUrl} from '../../utils/react';

type ImageTagProps = {
  alt: string,
  className?: string,
  style?: any,
  width?: number,
  height?: number,
  onClick?: () => void,
  onError?: () => void,
  onLoad?: () => void,
};

type Props = {
  src: string | Blob | File,
} & ImageTagProps;

export default function ImageRenderer(props: Props) {
  const {src, alt, ...rest} = props;

  const isBlob = typeof src !== 'string';

  const {objectURL} = useCreateObjectUrl(typeof src !== 'string' ? src : null);

  if (isBlob && !objectURL) return null;

  const source = isBlob ? objectURL : src;

  //$FlowFixMe
  return <img src={source} alt={alt} {...rest} />;
}
